import Axios from 'axios';

const isCoopAgent = async (listingId: string) => {
  const { data } = await Axios.get<{ hasBookedShowing: boolean }>(
    `/listing/${listingId}/is_coop_agent`,
  );
  return data;
};

export default isCoopAgent;
